__turbopack_context__.v({
  "button": "_9Ggzea_button",
  "container": "_9Ggzea_container",
  "elevated": "_9Ggzea_elevated",
  "menu": "_9Ggzea_menu",
  "option": "_9Ggzea_option",
  "selected": "_9Ggzea_selected",
});
